import React, { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Members from "@/pages/Members";
import Admin from "@/pages/Admin";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, API } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (res.ok) setUser(await res.json());
      } catch {}
      window.history.replaceState(null, "", "/members");
      navigate("/members", { replace: true });
    })();
  }, [location.hash, navigate, setUser, API]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1A3B2A] text-[#F7F7F4]">
      <p className="font-display text-3xl">Loggar in…</p>
    </div>
  );
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/members" element={<Members />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
